import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';

// yyyy-mm-dd in local time (avoids the UTC shift from toISOString)
const formatDate = (d) => {
    if (!d) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

function VendorPayReport() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [distributor, setDistributor] = useState('');
    const [distributors, setDistributors] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Distributor dropdown
    useEffect(() => {
        axios.get(`${baseUrl}dist-search/`)
            .then(response => setDistributors(response.data))
            .catch(error => console.log(error));
    }, []);

    // Reload whenever a filter changes
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate, distributor]);

    function fetchData() {
        setIsLoading(true);
        const url = `${baseUrl}vendor-pay-report/?start_date=${formatDate(startDate)}`
            + `&end_date=${formatDate(endDate)}&dist=${distributor}`;
        axios.get(url)
            .then(response => {
                // add serial number
                setRows(response.data.map((row, index) => ({...row, sno: index + 1})));
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setRows([]);
                setIsLoading(false);
            });
    }

    const columns = [
        {field: 'sno', headerName: 'S.No', width: 80},
        {
            field: 'dist__name', headerName: 'Distributor',
            renderCell: (params) => (
                <Link to={`/vendor-payment/${params.row.dist_id}/`}>
                    {params.value}
                </Link>
            ),
            width: 250,
        },
        {field: 'grn_no', headerName: 'GRN No', width: 130},
        {field: 'invoice', headerName: 'Invoice No', width: 130},
        {
    field: 'grn_date',
    headerName: 'GRN Date & Time',
    width: 180,
    renderCell: (params) => (
        <span>
            {params.row.grn_date} {params.row.add_time}
        </span>
    )
},
        {field: 'inv_date', headerName: 'Invoice Date', width: 130},
        {field: 'due_days', headerName: 'Due Days', width: 100, type: 'number'},
        {
            field: 'due_amount', headerName: 'Due Amount', width: 130, type: 'number',
            valueFormatter: (value) => Number(value ?? 0).toFixed(2),
        },
        {field: 'username', headerName: 'User Name', width: 140},
        {
            field: 'status', headerName: 'Status', width: 110,
            renderCell: (params) => (
                <span style={{
                    color: params.value === 'Paid' ? 'green' : 'red',
                    fontWeight: 600,
                }}>
                    {params.value}
                </span>
            ),
        },
    ];

    const totalDue = rows.reduce((sum, row) => {
        const v = parseFloat(row.due_amount);
        return isNaN(v) ? sum : sum + v;
    }, 0);

    const today = new Date();

    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-calendar-days" aria-hidden="true" style={{color: 'red'}}></i> Vendor Pay Report
            </h3>
            <div className="row">
                <div className="col-md-6">
                    <label className="control-label d-block">Select Date</label>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={today}
                        placeholderText="Please select From date"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                    />
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        maxDate={today}
                        placeholderText="Please select To date"
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showYearDropdown
                    />
                </div>
                <div className="col-md-6">
                    <div className="mb-4 form-control">
                        <label htmlFor="distributor" className="form-label">Search by Distributor</label>
                        <select id="distributor" value={distributor} className="form-control"
                                onChange={(e) => setDistributor(e.target.value)}>
                            <option value="">All Distributors</option>
                            {distributors.map((d) => (
                                <option key={d.id} value={d.id}>{d.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <DataGrid
                className="mt-4"
                sx={{
                    boxShadow: 4,
                    border: 4,
                    borderColor: 'primary.light',
                    '& .MuiDataGrid-cell:hover': {color: 'primary.main'},
                }}
                rows={rows}
                columns={columns}
                loading={isLoading}
                initialState={{pagination: {paginationModel: {pageSize: 10}}}}
                pageSizeOptions={[10, 25, 50, 100]}
                slots={{toolbar: GridToolbar}}
                autoHeight
            />
            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '24px', padding: '8px', fontWeight: 600}}>
                <div>Total Due</div>
                <div>{totalDue.toFixed(2)}</div>
            </div>
        </section>
    );
}

export default VendorPayReport;